import React from 'react';
import { FileText, Shield, Cookie } from 'lucide-react';

const PolicyMenu = ({ activeTab, onTabChange, isMobile }) => {
    const menuItems = [
        {
            id: 'terms',
            icon: FileText,
            label: 'Terms of Service'
        },
        {
            id: 'privacy',
            icon: Shield,
            label: 'Privacy Policy'
        },
        {
            id: 'cookies',
            icon: Cookie,
            label: 'Cookies Policy'
        }
    ];

    if (isMobile) {
        return (
            <div className="bg-white">
                {menuItems.map((item) => (
                    <button
                        key={item.id}
                        onClick={() => onTabChange(item.id)}
                        className={`w-full flex items-center gap-4 px-4 py-3 border-b border-neutral-200 last:border-0 transition-colors ${activeTab === item.id ? 'font-bold' : 'hover:bg-neutral-100'
                            }`}
                    >
                        <item.icon
                            className="w-6 h-6 text-black"
                            strokeWidth={activeTab === item.id ? 2.5 : 1.5}
                        />
                        <span className="text-[15px] text-black">{item.label}</span>
                    </button>
                ))}
            </div>
        );
    }

    return (
        <div className="bg-white border border-neutral-200 rounded-lg">
            <nav className="p-3 space-y-1">
                {menuItems.map((item) => {
                    const active = activeTab === item.id;
                    return (
                        <button
                            key={item.id}
                            onClick={() => onTabChange(item.id)}
                            className={`w-full flex items-center gap-4 px-3 py-3 rounded-lg transition-all relative ${active
                                    ? 'font-bold text-black'
                                    : 'text-black hover:bg-neutral-100'
                                }`}
                        >
                            {active && (
                                <div className="absolute -left-3 top-1/2 -translate-y-1/2 w-1 h-10 bg-black rounded-r-full" />
                            )}
                            <item.icon
                                className="w-6 h-6"
                                strokeWidth={active ? 2.5 : 1.5}
                            />
                            <span className="text-[15px]">{item.label}</span>
                        </button>
                    );
                })}
            </nav>
        </div>
    );
};

export default PolicyMenu;